import { Icon } from '@rbilabs/universal-components';
import { addMonths, format, isAfter } from 'date-fns';
import { useIntl } from 'react-intl';
import { StyleSheet, Text, View } from 'react-native';

import { localeStringToDateFnsLocale } from 'pages/support-v2/support-v2-orders-list-page/utils';
import { useLocale } from 'state/intl';
import { primitive } from 'styles/constants/primitives';

interface ExpirationWarningProps {
  pointsToExpire: number;
  expirationDate: string;
}

export const ExpirationWarning = ({ pointsToExpire, expirationDate }: ExpirationWarningProps) => {
  const { formatMessage } = useIntl();
  const { locale } = useLocale();

  const date = new Date(expirationDate);

  // If the date is over three months from now, don't show the component
  const threeMonthsFromNow = addMonths(new Date(), 3);
  if (isAfter(date, threeMonthsFromNow)) {
    return null;
  }

  const dateFormat = 'MMMM do';
  const utc = new Date(date.toUTCString().substring(0, 25));
  const formattedDate = format(utc, dateFormat, { locale: localeStringToDateFnsLocale(locale) });

  return (
    <View style={styles.expirationWarning}>
      <View style={styles.infoIconContainer}>
        <Icon variant="infoFill" size="$4" />
      </View>
      <Text style={styles.expirationText}>
        {formatMessage({ id: 'youHave', defaultMessage: 'You have' })}{' '}
        <Text style={styles.boldText}>
          {pointsToExpire} {formatMessage({ id: 'crowns', defaultMessage: 'Crowns' })}
        </Text>{' '}
        {formatMessage({ id: 'expiring', defaultMessage: 'expiring' })} {formattedDate}.
      </Text>
    </View>
  );
};

export const styles = StyleSheet.create({
  expirationWarning: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity4,
    paddingVertical: primitive.spacing.$2,
    paddingHorizontal: primitive.spacing.$4,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
  },
  infoIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    marginRight: primitive.spacing.$2,
    borderRadius: 10,
  },
  expirationText: {
    fontSize: primitive.fontSizes.xs,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.bk.$bbqBrown,
    lineHeight: 18,
    flex: 1,
  },
  boldText: {
    fontFamily: primitive.fontFamily.$headers,
  },
});
